import { Component, OnInit } from '@angular/core';
import { ScheduleTaskService } from 'src/app/services/eschedule-task/eschedule-task.service';
import { ScheduleTaskSearchItem } from '../../../../model/schedule-task/schedule-task-search-item';
import { ScheduledTask } from '../../../../enums/escheduled-task.enum';
import { NotificationToastService } from '../../../../services/notification-toast.service';
import { Base64ToBlobService } from '../../../../services/base64-to-blob.service';

@Component({
  selector: 'app-tool-schedule-task',
  templateUrl: './tool-schedule-task.component.html',
  styleUrls: ['./tool-schedule-task.component.css']
})
export class ToolScheduleTaskComponent implements OnInit {

  scheduleTaskSearchItems: ScheduleTaskSearchItem[] = [];
  loading: boolean;

  constructor(private scheduleTaskService: ScheduleTaskService ,
              private base64ToBlobService: Base64ToBlobService,
              private notificationToastService: NotificationToastService) { }

  async ngOnInit() {
    await this.loadScheduleTaskSearchItems();

  }

  async loadScheduleTaskSearchItems() {
    try {
      this.loading = true;
      this.scheduleTaskSearchItems = await this.scheduleTaskService.getScheduleTaskSearchItem();
      this.loading = false;
    } catch ( err ) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Tarea programada');
    } finally {
      this.loading = false;
    }
  }

  async doAction( scheduleTaskSearchItem: ScheduleTaskSearchItem ) {
    try {
      scheduleTaskSearchItem.LoadingAction = true;
      if (this.hasDownloadResponseAction(scheduleTaskSearchItem)) {
        const response =  this.scheduleTaskService
          .getScheduleTaskResponseLink(
            scheduleTaskSearchItem);
        this.download(scheduleTaskSearchItem.Name, response);
      }
    } catch ( err ) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Tarea programada');
    } finally {
      scheduleTaskSearchItem.LoadingAction = false;
    }
  }

  private download(name: string, response: string) {
    const link = document.createElement('a');
    link.href = response;
    link.download = name + '-' + new Date().getTime() + '.zip';
    link.click();
  }

  hasDownloadResponseAction( scheduleTaskSearchItem: ScheduleTaskSearchItem ) {
    return scheduleTaskSearchItem.ScheduleTaskTypeId === ScheduledTask.billingExportStudyReport ||
           scheduleTaskSearchItem.ScheduleTaskTypeId === ScheduledTask.exportAttached ||
           scheduleTaskSearchItem.ScheduleTaskTypeId === ScheduledTask.billingExportImages;
  }
}
